// Import necessary components and hooks
import { useState, useEffect, useRef } from "react";
import useFetchPatients from "../../Hooks/SearchPatient";
import PatientCard from "../../Components/PatientCard";
import { addDateTime } from "../../Redux_Services/slices/testSlice";
import Navbar from "../../Components/Navbar";
import sidevector from "../../assets/sidevector.svg";
import Lottie from "react-lottie";
import { animationDefaultOptions } from "../../Utils/Functions";
import TestRecordModal from "../../Components/TestRecordModal";
import { useDispatch, useSelector } from "react-redux";
import { translations } from "../../translation/translate";

const SearchPatient = () => {
  const [searchInput, setSearchInput] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const langData = useSelector((state) => state.langSlice.langData);

  const inputRef = useRef(null);

  // Fetch patients based on search input
  const { data: patientsData, loading } = useFetchPatients(searchInput);

  // Reset date/time when search changes
  useEffect(() => {
    dispatch(addDateTime(null));
  }, [loading, dispatch]);

  // Auto-focus input field
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleInputChange = (newValue) => {
    setSearchInput(newValue);
  };

  const handleModalOpen = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div className="min-h-screen w-full bg-[#C7CEE5] relative">

      {/* Navbar */}
      <Navbar
        ref={inputRef}
        searchInput={searchInput}
        handleInputChange={handleInputChange}
      />

      {/* Main Content */}
      <div className="flex flex-col items-center justify-center py-10 mt-10">
        {searchInput.trim() === "" ? (
          // No search entered
          <div className="mt-40">
            <Lottie
              isClickToPauseDisabled={true}
              height={200}
              width={200}
              options={animationDefaultOptions}
            />
            <p className="text-center mt-4 font-bold text-purple-500 text-4xl">
              {translations[langData].searchPatient}
            </p>
          </div>
        ) : loading ? (
          // Loading animation
          <p className="text-center mt-96 font-bold text-purple-500 text-4xl">
            {translations[langData].loading}
          </p>
        ) : patientsData?.patients?.length > 0 ? (
          // Show patient cards
          <div className="grid grid-cols-4 gap-x-40 gap-y-10 z-10 w-full max-w-screen-lg">
            {patientsData.patients.map((patient) => (
              <PatientCard
                key={patient.PatientID}
                patient={patient}
                labNo={patientsData.labNo}
                handleOpenModal={handleModalOpen}
              />
            ))}
          </div>
        ) : patientsData?.error === false &&
          patientsData?.patients?.length === 0 ? (
          // No records found
          <p className="text-center mt-96 font-bold text-purple-500 text-4xl">
            {translations[langData].noPatient} "{searchInput}"
          </p>
        ) : (
          <p className="text-center mt-96 font-bold text-purple-500 text-4xl">
            {translations[langData].loading}
          </p>
        )}
      </div>

      {/* Background Image */}
      <div className="absolute bottom-0 right-0 z-0 w-full lg:w-auto">
        <img src={sidevector} alt="sidevector" className="w-full lg:w-auto" />
      </div>

      <TestRecordModal isOpen={isModalOpen} onClose={handleModalOpen} />
    </div>
  );
};

export default SearchPatient;
